import React from "react";

import SeasonalPricingContent from "../components/seasonal-pricing/seasonal-pricing-content";

const SeasonalPricing = () => {
  return <SeasonalPricingContent />;
};

export default SeasonalPricing;
